import { createSelector } from 'reselect';
import _ from 'lodash';

const SettingBooth = {
    createSettingSelector: () => createSelector([
        (state) => state.adminSettingBooth.get.data,
    ], (result) => ({
        small_zone: {
            name: _.get(result, 'small_zone.name') || '',
            name_en: _.get(result, 'small_zone.name_en') || '',
            total_media: _.get(result, 'small_zone.total_media') || 0,
            image: _.get(result, 'small_zone.image') || 0,
            video: _.get(result, 'small_zone.video') || 0,
            audio: _.get(result, 'small_zone.audio') || 0,
            price: _.get(result, 'small_zone.price') || 0,
            price_ads: _.get(result, 'small_zone.price_ads') || 0,
            settings_display_info_product: _.get(result, 'small_zone.settings_display_info_product') || {},
        },
        standard_zone: {
            name: _.get(result, 'standard_zone.name') || '',
            name_en: _.get(result, 'standard_zone.name_en') || '',
            total_media: _.get(result, 'standard_zone.total_media') || 0,
            image: _.get(result, 'standard_zone.image') || 0,
            video: _.get(result, 'standard_zone.video') || 0,
            audio: _.get(result, 'standard_zone.audio') || 0,
            price: _.get(result, 'standard_zone.price') || 0,
            price_ads: _.get(result, 'standard_zone.price_ads') || 0,
            settings_display_info_product: _.get(result, 'standard_zone.settings_display_info_product') || {},
        },
        big_zone: {
            name: _.get(result, 'big_zone.name') || '',
            name_en: _.get(result, 'big_zone.name_en') || '',
            total_media: _.get(result, 'big_zone.total_media') || 0,
            image: _.get(result, 'big_zone.image') || 0,
            video: _.get(result, 'big_zone.video') || 0,
            audio: _.get(result, 'big_zone.audio') || 0,
            price: _.get(result, 'big_zone.price') || 0,
            price_ads: _.get(result, 'big_zone.price_ads') || 0,
            settings_display_info_product: _.get(result, 'big_zone.settings_display_info_product') || {},
        },
        grand_zone: {
            name: _.get(result, 'grand_zone.name') || '',
            name_en: _.get(result, 'grand_zone.name_en') || '',
            total_media: _.get(result, 'grand_zone.total_media') || 0,
            image: _.get(result, 'grand_zone.image') || 0,
            video: _.get(result, 'grand_zone.video') || 0,
            audio: _.get(result, 'grand_zone.audio') || 0,
            price: _.get(result, 'grand_zone.price') || 0,
            price_ads: _.get(result, 'grand_zone.price_ads') || 0,
            settings_display_info_product: _.get(result, 'grand_zone.settings_display_info_product') || {},
        },
        ads_settings: {
            register_ads: _.get(result, 'ads_settings.register_ads') || 0,
            total_ads: _.get(result, 'ads_settings.total_ads') || 0,
            register_ads_max: _.get(result, 'ads_settings.register_ads_max') || 0,
            price_ads: _.get(result, 'ads_settings.price_ads') || 0,
        },
    })),
};

export default SettingBooth;
